import {
  ADD_LICENSE,
  ADD_LICENSE_SUCCESSFUL,
  ADD_LICENSE_ERROR,
  GET_LICENSE,
  GET_LICENSE_SUCCESSFUL,
  GET_LICENSE_FAILED,
  UPDATE_LICENSE,
  UPDATE_LICENSE_SUCCESSFUL,
  UPDATE_LICENSE_FAILED,
  ADD_COMPLIANCE_ADDONS,
  ADD_COMPLIANCE_ADDONS_SUCCESSFUL,
  ADD_COMPLIANCE_ADDONS_FAILED,
  DELETE_LICENSE,
  DELETE_LICENSE_SUCCESSFUL,
  DELETE_LICENSE_FAILED,
  CLEAR_ALL_MESSAGES,
  CLEAR_ALL_MESSAGES_SUCCESS,
  CLEAR_SUCCESS_MESSAGES,
  CLEAR_SUCCESS_MESSAGES_SUCCESS,
  CLEAR_FAILURE_MESSAGES,
  CLEAR_FAILURE_MESSAGES_SUCCESS,
} from "./actionTypes";

const initialState = {
  isAddingLicense: false,
  addLicenseError: null,
  addLicenseMessage: null,

  isUpdatingLicense: false,
  updateLicenseError: null,
  updateLicenseMessage: null,

  isAddingComplianceAddons: false,
  addComplianceAddonsError: null,
  addComplianceAddonsMessage: null,

  isDeletingLicense: false,
  deleteLicenseError: null,
  deleteLicenseMessage: null,

  isGettingLicense: false,
  getLicenseError: null,
  getLicenseMessage: null,
  // message: null,
  // isLoaded: false,
  // isLoading: false,
};

const globalLicense = (state = initialState, action) => {
  console.log("Action Type :: ", action.type);
  switch (action.type) {
    // case ADD_USER:
    //   state = {
    //     ...state,
    //     // loading: true,
    //     isAddingUser: true,
    //     addUserError: null,
    //     user: null,
    //   };
    //   break;
    // case ADD_USER_SUCCESSFUL:
    //   state = {
    //     ...state,
    //     // loading: false,
    //     user: action.payload.user,
    //     isAddingUser: false,
    //     addUserError: null,
    //   };
    //   break;
    // case ADD_USER_ERROR:
    //   // console.log("Reducer :: ", action.payload.error.response.data)
    //   state = {
    //     ...state,
    //     // loading: false,
    //     isAddingUser: false,
    //     addUserError: action.payload.error.response.data,
    //   };
    //   console.log("Reducer :: ", state.addUserError);
    //   break;

    case GET_LICENSE:
      state = {
        ...state,
        isGettingLicense: true,
        getLicenseError: null,
        getLicenseMessage: null,
        // isLoading: true,
        // //Added the following for spinner
        // loading: true,
      };
      break;

    case GET_LICENSE_SUCCESSFUL:
      console.log("payload = ", action.payload);
      // console.log("License = ", Object.values(action.payload.user));
      // const users = action.payload.user;
      // const usersWithIds = users.map((user, index) => {
      //   console.log("payload = ", user);
      //   // Use the index as the unique id for each user object
      //   return { ...user, index };
      // });
      state = {
        ...state,
        // isLoading: false,
        isGettingLicense: false,
        getLicenseError: null,
        getLicenseMessage: "License Data Retrieved Successfully",
        //Added for spinner
        // loading: false,
        // isLoaded: true,
        license: action.payload.license,
      };
      break;

    case GET_LICENSE_FAILED:
      state = {
        ...state,
        // loading: false,
        isGettingLicense: false,
        getLicenseError: action.payload.error,
        // message: action.payload.response.data,
        // userError: action.payload.response.status,
      };
      break;

    //Added for Update/delete License
    case UPDATE_LICENSE:
      console.log(
        "reducer -> UPDATE_LICENSE called with license: ",
        action.payload.license
      );
      state = {
        ...state,
        // loading: true,
        isUpdatingLicense: true,
        updateLicenseError: null,
        license: action.payload.license,
      };
      console.log("reducer -> UPDATE_LICENSE state is ", state);
      break;
    case UPDATE_LICENSE_SUCCESSFUL:
      console.log(
        "reducer -> UPDATE_LICENSE_SUCCESSFUL called with ",
        action.payload.license
      );
      state = {
        ...state,
        isUpdatingLicense: false,
        updateLicenseError: null,
        updateLicenseMessage: "License updated successfully.",
        license: action.payload.license,
      };
      break;

    case UPDATE_LICENSE_FAILED:
      state = {
        ...state,
        isUpdatingLicense: false,
        updateLicenseError: action.payload.error,
      };
      break;
    //For adding compliance addons
    case ADD_COMPLIANCE_ADDONS:
      console.log(
        "reducer -> ADD_COMPLIANCE_ADDONS called with complianceAddons: ",
        action.payload.complianceAddons
      );
      state = {
        ...state,
        isAddingComplianceAddons: true,
        addComplianceAddonsError: null,
        complianceAddons: action.payload.complianceAddons,
      };
      console.log("reducer -> ADD_COMPLIANCE_ADDONS state is ", state);
      break;
    case ADD_COMPLIANCE_ADDONS_SUCCESSFUL:
      console.log("reducer -> ADD_COMPLIANCE_ADDONS_SUCCESSFUL called");
      state = {
        ...state,
        isAddingComplianceAddons: false,
        addComplianceAddonsError: null,
        addComplianceAddonsMessage: "Compliance Addons added successfully!",
      };
      console.log(
        "reducer -> ADD_COMPLIANCE_ADDONS_SUCCESSFUL state is ",
        state
      );
      break;
    case ADD_COMPLIANCE_ADDONS_FAILED:
      console.log("reducer -> ADD_COMPLIANCE_ADDONS_FAILED called with error = ", action.payload.error);
      state = {
        ...state,
        isAddingComplianceAddons: false,
        addComplianceAddonsError: action.payload.error,
      };
      break;

    // case DELETE_COGNITO_USER:
    //   state = {
    //     ...state,
    //     // loading: true,
    //     isDeletingUser: true,
    //     deleteUserError: null,
    //     username: null,
    //   };
    //   break;

    // case DELETE_COGNITO_USER_SUCCESSFUL:
    //   state = {
    //     ...state,
    //     isUserDeleting: false,
    //     deleteUserError: null,
    //     username: action.payload.username,
    //   };
    //   break;
    // case DELETE_COGNITO_USER_FAILED:
    //   state = {
    //     ...state,
    //     isUserDeleting: false,
    //     deleteUserError: action.payload.error,
    //   };
    // break;
    case CLEAR_ALL_MESSAGES_SUCCESS:
      state = {
        ...state,
        getLicenseMessage: null,
        addLicenseMessage: null,
        updateLicenseMessage: null,
        deleteLicenseMessage: null,

        getLicenseError: null,
        addLicenseError: null,
        updateLicenseError: null,
        deleteLicenseError: null,
      };
      break;
    case CLEAR_SUCCESS_MESSAGES_SUCCESS:
      state = {
        ...state,
        getLicenseMessage: null,
        addLicenseMessage: null,
        updateLicenseMessage: null,
        deleteLicenseMessage: null,
      };
      break;
    case CLEAR_FAILURE_MESSAGES_SUCCESS:
      state = {
        ...state,
        getLicenseError: null,
        addLicenseError: null,
        updateLicenseError: null,
        deleteLicenseError: null,
      };
      break;

    default:
      return state;
  }
  return state;
};

export default globalLicense;
